import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Globe, Instagram, Linkedin, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-medical-blue text-white pt-24 pb-12" role="contentinfo" data-id="element-21">
      <div className="max-w-7xl mx-auto px-6" data-id="element-22">
        <div className="grid lg:grid-cols-4 gap-16 mb-20" data-id="element-23">
          <div className="lg:col-span-2" data-id="element-24">
            <Link to="/" aria-label="Global Restorative Home" data-id="element-25">
              <img src="https://cdn.magicpatterns.com/uploads/5kYZM3bXgFrv2MfbGGG85T/Global_Restorative3_(1).jpg" alt="Global Restorative Logo" className="h-24 w-auto mb-10 rounded-lg" data-id="element-26" />
            </Link>
            <p className="text-2xl font-heading italic mb-8 max-w-md leading-tight text-medical-silver" data-id="element-27">
              "...Restoring Health. Renewing Minds. Rebuilding Lives."
            </p>
            <p className="text-sm opacity-60 max-w-sm leading-relaxed mb-10" data-id="element-28">
              Global Restorative Health & Wellness LLC is a comprehensive
              healthcare provider dedicated to helping individuals and families
              restore their health and rebuild emotional strength.
            </p>
            <div className="flex gap-6" data-id="element-29">
              {[Instagram, Linkedin, Facebook].map((Icon, i) => <a key={i} href="#" className="p-3 bg-white/5 rounded-full hover:bg-medical-red transition-all" aria-label="social media" data-id="element-30">
                  <Icon size={20} data-id="element-31" />
                </a>)}
            </div>
          </div>

          <div data-id="element-32">
            <h4 className="text-medical-red font-display font-bold uppercase tracking-widest text-xs mb-10" data-id="element-33">
              Navigation
            </h4>
            <ul className="space-y-6 font-display font-semibold" data-id="element-34">
              {['Home', 'About', 'Services', 'Programs', 'Blog', 'Contact'].map(item => <li key={item} data-id="element-35">
                    <Link to={item === 'Home' ? '/' : `/${item.toLowerCase()}`} className="opacity-60 hover:opacity-100 hover:text-medical-red transition-all" data-id="element-36">
                      {item}
                    </Link>
                  </li>)}
            </ul>
          </div>

          <div data-id="element-37">
            <h4 className="text-medical-red font-display font-bold uppercase tracking-widest text-xs mb-10" data-id="element-38">
              Contact Details
            </h4>
            <ul className="space-y-8 text-sm font-semibold" data-id="element-39">
              <li className="flex items-start gap-4" data-id="element-40">
                <Mail size={18} className="text-medical-red shrink-0" data-id="element-41" />
                <span className="opacity-60" data-id="element-42">info@globalrestorative.com</span>
              </li>
              <li className="flex items-start gap-4" data-id="element-43">
                <Phone size={18} className="text-medical-red shrink-0" data-id="element-44" />
                <span className="opacity-60" data-id="element-45">+1 (555) 000-0000</span>
              </li>
              <li className="flex items-start gap-4" data-id="element-46">
                <Globe size={18} className="text-medical-red shrink-0" data-id="element-47" />
                <span className="opacity-60" data-id="element-48">
                  Telehealth Services Worldwide
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-8 text-[10px] uppercase tracking-widest font-bold opacity-40" data-id="element-49">
          <p data-id="element-50">
            © 2026 Global Restorative Health & Wellness LLC. All rights
            reserved.
          </p>
          <div className="flex gap-12" data-id="element-51">
            <Link to="#" className="hover:opacity-100 transition-opacity" data-id="element-52">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:opacity-100 transition-opacity" data-id="element-53">
              Terms of Service
            </Link>
            <Link to="#" className="hover:opacity-100 transition-opacity" data-id="element-54">
              Accessibility
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}